var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h5-banner"},[(_vm.bannerImage)?_c('img',{staticClass:"banner-img",attrs:{"src":_vm.bannerImage,"alt":"传智AI漫剧","role":"button","tabindex":"0","aria-label":"打开在线咨询"},on:{"click":_vm.handleBannerClick}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }